module.exports = __webpack_public_path__ + "img/product_80.b992e60.svg";